import { LessonType } from '@app/store/shared/models';
import { LessonValue } from './lesson.value';

export class LessonValueDto {
    name?: string;
    type?: LessonType;
    duration?: number;
    materialIds?: string[];
    // Video/Audio specific
    transcription?: string | null;
    mediaId?: string | null;
    mediaPlaceholderId?: string | null;
    completionEnforcement?: boolean;

    constructor(data: LessonValue) {
        if (data.name !== undefined) {
            this.name = data.name;
        }
        this.type = data.type;
        if (data.duration !== undefined) {
            this.duration = data.duration;
        }
        if (data.materialIds !== undefined) {
            this.materialIds = data.materialIds;
        }

        // Type-specific fields
        if (data.type === 'video') {
            if (data.transcription !== undefined) {
                this.transcription = data.transcription || null;
            }

            if (data.completionEnforcement !== undefined) {
                this.completionEnforcement = data.completionEnforcement;
            }

            // Only send mediaId if changed from original
            const originalMediaStr = data.originalMediaId != null ? String(data.originalMediaId) : null;
            if (data.mediaId !== undefined && data.mediaId !== originalMediaStr) {
                this.mediaId = data.mediaId;
            }

            // Only send mediaPlaceholderId if changed from original
            const originalPlaceholderStr = data.originalMediaPlaceholderId != null ? String(data.originalMediaPlaceholderId) : null;
            if (data.mediaPlaceholderId !== undefined && data.mediaPlaceholderId !== originalPlaceholderStr) {
                this.mediaPlaceholderId = data.mediaPlaceholderId;
            }
        } else if (data.type === 'audio') {
            if (data.transcription !== undefined) {
                this.transcription = data.transcription || null;
            }

            // Only send mediaId if changed from original
            const originalMediaStr = data.originalMediaId != null ? String(data.originalMediaId) : null;
            if (data.mediaId !== undefined && data.mediaId !== originalMediaStr) {
                this.mediaId = data.mediaId;
            }
        } else if (data.type === 'text') {
            // Only send mediaId if changed from original
            const originalMediaStr = data.originalMediaId != null ? String(data.originalMediaId) : null;
            if (data.mediaId !== undefined && data.mediaId !== originalMediaStr) {
                this.mediaId = data.mediaId;
            }
        }
    }
}
